<template lang="pug">
.content
  .row
    .col-md-12
      md-card(title='Danh sách thành tích', backgroundColor='purple')
        span.headerRight
          i.material-icons.list-action(v-on:click='onItemAdd') add
        md-table(:data='achievements', :columns='columns', v-on:onItemDelete='onItemDelete', v-on:onItemEdit='onItemEdit')
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import MdNotification from '@/core/components/mdNotification'
import AchievementForm from './AchievementForm'
import moment from 'moment'

export default {
  components: {
    MdNotification
  },
  data() {
    return {
      achievements: [],
      columns: [
        { key: 'id', title: 'ID' },
        { key: 'name', title: 'Tên thành tích' },
        { key: 'icon', title: 'Icon', type: 'image' },
        { key: 'created_at', title: 'Ngày tạo', type: 'date' },
        { key: 'updated_at', title: 'Ngày cập nhật', type: 'date' },
        { key: 'action', title: 'Action', type: 'action' }
      ]
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    onItemDelete(payload) {
      try {
        this.$modal.show('dialog', {
          title: 'Xác nhận',
          text: 'Bạn có chắc muốn xóa thành tích <strong>' + payload.name + '</strong>',
          buttons: [
            {
              title: 'Xóa',
              default: true,
              handler: () => {
                this.$apollo.mutate({
                  mutation: gql(graphql.DELETE_ACHIEVES),
                  variables: {
                    id: payload.id,
                    is_delete: true
                  },
                  update: (store, { data: { update_achievement } }) => {
                    // Read the data from our cache for this query.
                    const data = store.readQuery({ query: gql(graphql.GET_ACHIEVES) })
                    var toBeDeleted = null
                    for (var i = 0; i < data.achievement.length; i++) {
                      var sub = data.achievement[i]
                      if (sub.id === payload.id) {
                        toBeDeleted = i
                      }
                    }
                    if (toBeDeleted !== null) data.achievement.splice(toBeDeleted, 1)
                    store.writeQuery({ query: gql(graphql.GET_ACHIEVES), data })
                  }
                }).then((data) => {
                  // Result
                  this.showNotification('Thành tích đã bị xóa', 'warning', 'top', 'right', 7000)
                  this.$modal.hide('dialog')
                }).catch((error) => {
                  // Error
                  console.error(error)
                })
              }
            },
            {
              title: 'Hủy'
            }
          ]
        })
      } catch (e) {
        console.error(e)
      }
    },
    onItemEdit(payload) {
      this.$modal.show(AchievementForm, {
        id: payload.id,
        title: payload.name,
        icon: payload.icon,
        saveFunction: this.onAchievementFormSave
      }, {
        height: 'auto',
        classes: ['col-md-6', 'col-12'],
        adaptive: true,
        clickToClose: false
      })
    },
    onAchievementFormSave(payload) {
      this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_ACHIEVES),
        variables: {
          id: payload.id,
          icon: payload.icon,
          name: payload.title
        },
        update: (store, { data: { update_achievement } }) => {
          // Read the data from our cache for this query.
          const data = store.readQuery({ query: gql(graphql.GET_ACHIEVES) })
          var subUpdated = data.achievement.find(s => s.id === payload.id)
          subUpdated.icon = payload.icon
          subUpdated.name = payload.title
          subUpdated.updated_at = moment()
          store.writeQuery({ query: gql(graphql.GET_ACHIEVES), data })
        }
      }).then((data) => {
        // Result
        this.showNotification('Thành tích ' + payload.title + ' đã được cập nhật', 'success', 'top', 'right', 5000)
      }).catch((e) => {
        // Error
        console.error(e)
      })
    },
    onItemAdd() {
      this.$modal.show(AchievementForm, {
        saveFunction: this.onAchievementFormAdd
      }, {
        height: 'auto',
        classes: ['col-md-6', 'col-12'],
        adaptive: true,
        clickToClose: false
      })
    },
    onAchievementFormAdd(payload) {
      this.$apollo.mutate({
        mutation: gql(graphql.CREATE_ACHIEVES),
        variables: {
          icon: payload.icon,
          name: payload.title
        },
        update: (store, { data: { insert_achievement } }) => {
          // Read the data from our cache for this query.
          const data = store.readQuery({ query: gql(graphql.GET_ACHIEVES) })
          const insertedAchieves = insert_achievement.returning
          data.achievement.splice(0, 0, insertedAchieves[0])
          store.writeQuery({ query: gql(graphql.GET_ACHIEVES), data })
        }
      }).then((data) => {
        // Result
        this.showNotification('Thành tích ' + payload.title + ' đã thêm', 'success', 'top', 'right', 5000)
      }).catch((e) => {
        // Error
        console.error(e)
      })
    }
  },
  apollo: {
    'achievements': {
      query: gql(graphql.GET_ACHIEVES),
      update: data => data.achievement
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?564eeef8